import {
  ApplicationConfig,
  inject,
  isDevMode,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withRouterConfig,
  withViewTransitions,
} from '@angular/router';
import { SwUpdate, provideServiceWorker } from '@angular/service-worker';
import { filter, firstValueFrom, switchMap, tap } from 'rxjs';
import { SplHttpAuthService } from '@splitory/splitory-http';
import { splMaterialProviders } from '@splitory/splitory-ui';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    ...splMaterialProviders,
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withViewTransitions(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
        paramsInheritanceStrategy: 'always',
      }),
    ),
    provideHttpClient(withFetch()),
    provideAppInitializer(() => {
      const authService = inject(SplHttpAuthService);
      return firstValueFrom(authService.loadAuthenticatedUser());
    }),
    provideAppInitializer(() => {
      const swUpdate = inject(SwUpdate);
      const matSnackBar = inject(MatSnackBar);

      if (!swUpdate.isEnabled) {
        return;
      }

      swUpdate.versionUpdates
        .pipe(
          filter((evt) => evt.type === 'VERSION_READY'),
          switchMap(() =>
            matSnackBar
              .open('New version available', 'Update Now', {
                horizontalPosition: 'center',
                verticalPosition: 'top',
              })
              .onAction(),
          ),
          tap(async () => {
            await swUpdate.activateUpdate();
            document.location.reload();
          }),
        )
        .subscribe();
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
